<div *ngIf="page == 'lista'" class="customPanel">
  <span (click)="openInfo()" style="position: absolute; cursor: pointer" class="material-icons-outlined textXM">
    help
  </span>
  <h1 class="textM" style="text-align: center; height: 7%" mat-dialog-title>
    {{this.localiser.get('fade.groups.title')}}
  </h1>

  <div mat-dialog-content class="bodyForm" *ngIf="grupos.length > 0">
    <table style="width: 80%; margin: auto; border-spacing: 0 20px; border-collapse: separate">
      <tr *ngFor="let grupo of grupos" style="text-align: center; margin-bottom: 5%">
        <td><h3 class="textS+">{{grupo.nombre}}</h3>
          <h3 class="textS">GW: {{grupo.idConcentrador}}</h3></td>
        <td>
          <span (click)="editGrupoPage(grupo)" style="color: #F2A356; cursor: pointer"
                class="material-icons-outlined textXM">
            edit
          </span>
        </td>
        <td>
          <span (click)="deleteGrupoPage(grupo)" style="color: #FF0C41; cursor: pointer"
                class="material-icons-outlined textXM">
            delete
          </span>
        </td>
      </tr>
    </table>
  </div>

  <div mat-dialog-content class="bodyForm" *ngIf="grupos.length <= 0">
    <div class="middleText" style="margin-top: 5%">
      <h3 class="textM centerVert">{{this.localiser.get('fade.groups.noGroups')}}</h3>
    </div>
  </div>

  <div mat-dialog-actions>
    <div class="col" style="text-align: center">
      <button class="customButtonColor textS" mat-button
              (click)="onCancelClick()">{{this.localiser.get('fade.buttonExit')}}</button>
    </div>
    <div class="col" style="text-align: center">
      <button class="customButtonColor textS" mat-button
              (click)="changePageToNew()">{{this.localiser.get('fade.groups.buttonCreate')}}</button>
    </div>
  </div>


</div>

<!-- NEW GROUP -->
<div *ngIf="page == 'new'" class="customPanel">
  <h1 class="textM" style="text-align: center; height: 7%" mat-dialog-title>
    {{this.localiser.get('fade.groups.buttonCreate')}}
  </h1>

  <div mat-dialog-content class="bodyForm">

    <div class="row rowForm">
      <div class="col">
        <h5 class="textS+">{{this.localiser.get('fade.groups.name')}}</h5>
        <input [(ngModel)]="nombre" type="text" class="textS+" maxlength="40" style="width: 50%">
      </div>
    </div>

    <div class="row rowForm">
      <div class="col">
        <h5 class="textS+">{{this.localiser.get('fade.groups.description')}}</h5>
        <textarea [(ngModel)]="descripcion" type="text" class="inputWidth textS+" style="height: 50%" maxlength="200">
          </textarea>
      </div>
    </div>

    <div class="row rowForm">
      <div class="col">
        <mat-form-field appearance="fill" style="width: 70%">
          <mat-label class="textS">{{this.localiser.get('fade.groups.gateway')}}:</mat-label>
          <mat-select (selectionChange)="selectConcentrador($event)" [(ngModel)]="concentradorSelected"
                      [placeholder]="this.localiser.get('fade.groups.gateway')" class="selectFilter textS">
            <mat-option class="textS" *ngFor="let concentrador of getGWMant()"
                        [value]="concentrador">{{concentrador.nombre}} ({{concentrador.idDispositivo}})
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col">
        <h3 *ngIf="concentradorSelected != undefined"
            class="textS+ centerVert">{{this.localiser.get('fade.groups.number')}}: {{sizeConcentrador}}</h3>
        <h3 *ngIf="concentradorSelected != undefined && sizeConcentrador >= 128"
            class="textS+ centerVert">{{this.localiser.get('fade.groups.maximumNumber')}}</h3>
        <h3 *ngIf="selectedError" class="textS+ centerVert">{{this.localiser.get('fade.groups.selectError')}}</h3>
      </div>
    </div>

  </div>

  <div mat-dialog-actions>
    <div class="col" style="text-align: center">
      <button class="customButtonColor textS" mat-button
              (click)="changePageToLista()">{{this.localiser.get('fade.buttonBack')}}</button>
    </div>
    <div class="col" style="text-align: center">
      <button class="customButtonColor textS" mat-button
              (click)="newGrupo()">{{this.localiser.get('fade.buttonSave')}}</button>
    </div>
  </div>
</div>

<div *ngIf="page == 'edit'" class="customPanel">

  <div class="row" style="border-bottom: 1px solid white">
    <div class="col" (click)="changeEditarLuminarias(0)" style="cursor:pointer; border-right: 1px solid white">
      <h1 class="textM titleEdit" mat-dialog-title [ngClass]="{titleTransparency: editarLuminarias != 0}">
        {{this.localiser.get('fade.groups.editName')}}
      </h1>
    </div>
    <div class="col" (click)="changeEditarLuminarias(1)" style="cursor:pointer; border-right: 1px solid white">
      <h1 class="textM titleEdit" mat-dialog-title [ngClass]="{titleTransparency: editarLuminarias != 1}">
        {{this.localiser.get('fade.groups.editLuminaries')}}
      </h1>
    </div>
    <div class="col" (click)="changeEditarLuminarias(2)" style="cursor:pointer">
      <h1 class="textM titleEdit" mat-dialog-title [ngClass]="{titleTransparency: editarLuminarias != 2}">
        {{this.localiser.get('fade.groups.editSensors')}}
      </h1>
    </div>
  </div>

  <div *ngIf="editarLuminarias == 0" style="height: 90%;">

    <div mat-dialog-content class="bodyFormEdit">

      <div class="row rowForm">
        <div class="col">
          <h5 class="textS+">{{this.localiser.get('fade.groups.name')}}</h5>
          <input [(ngModel)]="nombre" type="text" class="textS+" maxlength="40" style="width: 50%">
        </div>
      </div>

      <div class="row rowForm">
        <div class="col">
          <h5 class="textS+">{{this.localiser.get('fade.groups.description')}}</h5>
          <textarea [(ngModel)]="descripcion" type="text" class="inputWidth textS+" style="height: 150%"
                    maxlength="200">
          </textarea>
        </div>
      </div>

    </div>

    <div mat-dialog-actions>
      <div class="col" style="text-align: center">
        <button class="customButtonColor textS" mat-button
                (click)="changePageToLista()">{{this.localiser.get('fade.buttonBack')}}</button>
      </div>
      <div class="col" style="text-align: center">
        <button class="customButtonColor textS" mat-button
                (click)="updateGrupo()">{{this.localiser.get('fade.buttonSave')}}</button>
      </div>
    </div>

  </div>

  <div *ngIf="editarLuminarias == 1" style="height: 90%">
    <div mat-dialog-content class="bodyFormEdit">

      <div class="row rowForm" style="display: block; width: 100%">

        <div class="row">
          <div class="col" style="text-align: left; padding-left: 5%; height: fit-content">
            <div class="row" style="height: 50%">
              <label class="textS labelSearch">{{this.localiser.get('devices.searcher')}}</label>
            </div>
            <div class="row" style="height: 50%">
            <span class="material-icons-outlined textXM" style="color: white; width: 10%">
                search
              <!--filter_alt_off - Se hace muy grande-->
            </span>
              <input [(ngModel)]="searcherLuminarias" type="text" class="textS searcherInput" style="width: 65%"
                     (input)="loadLuminarias()" maxlength="50">
            </div>
          </div>
          <div class="col-3">
            <mat-form-field appearance="fill">
              <mat-label class="textS">{{this.localiser.get("devices.floorplan")}}</mat-label>
              <mat-select (selectionChange)="selectPlano($event)" [(ngModel)]="planoSelected" [placeholder]="'Plano'"
                          class="selectFilter textS">
                <mat-option class="textS" [value]="'all'"><b>{{this.localiser.get("fade.groups.all")}}</b></mat-option>
                <mat-option class="textS" *ngFor="let plano of planos" [value]="plano">{{plano.nombre}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="col">
            <mat-form-field appearance="fill">
              <mat-label class="textS">{{this.localiser.get("devices.zone")}}</mat-label>
              <mat-select (selectionChange)="selectZona($event)" [(ngModel)]="zonaSelected" [placeholder]="'Zona'"
                          class="selectFilter textS">
                <mat-option class="textS" [value]="'all'"><b>{{this.localiser.get("fade.groups.all")}}</b></mat-option>
                <mat-option class="textS" *ngFor="let zona of zonas" [value]="zona">{{zona.nombre}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <div class="col">
          <h5>{{this.localiser.get("devices.luminaries")}}</h5>

          <table style="width:100%; white-space: nowrap">
            <tr class="bottom-border">
              <th class="textS">{{this.localiser.get("fade.groups.addLuminary")}}</th>
              <th class="textS">{{this.localiser.get("devices.name")}}</th>
              <th class="textS">ID</th>
              <th class="textS">{{this.localiser.get("devices.floorplan")}}</th>
              <th class="textS">{{this.localiser.get("devices.zone")}}</th>
              <th class="textS">{{this.localiser.get("fade.groups.confirmedhub")}}</th>
              <th class="textS">{{this.localiser.get("fade.groups.sendConfiguration")}}</th>
              <th class="textS">{{this.localiser.get("fade.groups.getHubsMap")}}</th>
            </tr>
            <tr *ngFor="let luminaria of luminarias" style="background-color: rgba(255, 255, 255, 0.1)">
              <td class="separator">
                <mat-checkbox [checked]="containsLuminaria(luminaria)"
                              (change)="change(luminaria.idDispositivo, $event.checked)"
                              [disabled]="!luminaria.hubPpalConfirmado">

                </mat-checkbox>
              </td>
              <td class="textS">{{luminaria.nombre}}</td>
              <td class="textS">{{luminaria.idDispositivo}}</td>
              <td class="textS">
                {{getPlano(luminaria.idPlano)}}
              </td>
              <td class="textS">
                {{getZona(luminaria.idZona)}}
              </td>
              <td>
                {{ getLabelHubConfirmado(luminaria.hubPpalConfirmado) }}
              </td>
              <td class="textS">
                <div style="align-items: center; display: flex; justify-content: center;">
                  <span (click)="luminaria.hubPpalConfirmado ? sendMaskGrupo(luminaria.idDispositivo) : null" [disabled]="!luminaria.hubPpalConfirmado" class="material-icons-outlined {{luminaria.hubPpalConfirmado ? 'iconSend' : ''}} textXXM">arrow_right_alt</span>
                </div>
              </td>
              <td class="textS">
                <div *ngIf="!luminaria.hubPpalConfirmado" style="align-items: center; display: flex; justify-content: center;">
                  <span (click)="sendGetHubsMap(luminaria.idDispositivo)" class="material-icons-outlined iconSend textXXM">arrow_right_alt</span>
                </div>
              </td>
            </tr>
          </table>
        </div>
      </div>

    </div>

    <div mat-dialog-actions>
      <div class="col" style="text-align: center">
        <button class="customButtonColor textS" mat-button
                (click)="changePageToLista()">{{this.localiser.get("fade.buttonBack")}}</button>
      </div>
      <div *ngIf="!luminariaGuardada" class="col" style="text-align: center">
        <button class="customButtonColor textS" mat-button
                (click)="updateGrupo()">{{this.localiser.get("fade.buttonSave")}}</button>
      </div>
      <div *ngIf="luminariaGuardada" class="col" style="text-align: center">
        <button class="customButtonColorDone textS" mat-button (click)="updateGrupo()">
          {{this.localiser.get("fade.buttonSaved")}}
          <span class="material-icons-outlined marginAuto">done</span>
        </button>
      </div>
    </div>

  </div>

  <div *ngIf="editarLuminarias == 2" style="height: 90%">
    <div mat-dialog-content class="bodyFormEdit">

      <div class="row rowForm" style="display: block; width: 100%">

        <div class="row">
          <div class="col" style="text-align: left; padding-left: 5%; height: fit-content">
            <div class="row" style="height: 50%">
              <label class="textS labelSearch">{{this.localiser.get('devices.searcher')}}</label>
            </div>
            <div class="row" style="height: 50%">
            <span class="material-icons-outlined textXM" style="color: white; width: 10%">
                search
            </span>
              <input [(ngModel)]="searcherLuminarias" type="text" class="textS searcherInput" style="width: 65%"
                     (input)="loadLuminarias()" maxlength="50">
            </div>
          </div>
          <div class="col-3">
            <mat-form-field appearance="fill">
              <mat-label class="textS">{{this.localiser.get("devices.floorplan")}}</mat-label>
              <mat-select (selectionChange)="selectPlano($event)" [(ngModel)]="planoSelected" [placeholder]="'Plano'"
                          class="selectFilter textS">
                <mat-option class="textS" [value]="'all'"><b>{{this.localiser.get("fade.groups.all")}}</b></mat-option>
                <mat-option class="textS" *ngFor="let plano of planos" [value]="plano">{{plano.nombre}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="col">
            <mat-form-field appearance="fill">
              <mat-label class="textS">{{this.localiser.get("devices.zone")}}</mat-label>
              <mat-select (selectionChange)="selectZona($event)" [(ngModel)]="zonaSelected" [placeholder]="'Zona'"
                          class="selectFilter textS">
                <mat-option class="textS" [value]="'all'"><b>{{this.localiser.get("fade.groups.all")}}</b></mat-option>
                <mat-option class="textS" *ngFor="let zona of zonas" [value]="zona">{{zona.nombre}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <div class="col">
          <h5>{{this.localiser.get('fade.groups.sensorsTitle')}}</h5>

          <table style="width:100%; white-space: nowrap">
            <tr class="bottom-border">
              <th class="textS">{{this.localiser.get("fade.groups.addLuminary")}}</th>
              <th class="textS">{{this.localiser.get("devices.name")}}</th>
              <th class="textS">ID</th>
              <th class="textS">{{this.localiser.get("devices.floorplan")}}</th>
              <th class="textS">{{this.localiser.get("devices.zone")}}</th>
            </tr>
            <ng-container *ngFor="let luminaria of luminarias" style="display: contents">
              <tr *ngIf="containsLuminariaYSensor(luminaria.idDispositivo)" style="background-color: rgba(255, 255, 255, 0.1)">
                <td class="separator">
                  <mat-checkbox [checked]="containsSensor(luminaria.idDispositivo)"
                                (change)="changeSensor(luminaria.idDispositivo, $event.checked)">

                  </mat-checkbox>
                </td>
                <td class="textS">{{luminaria.nombre}}</td>
                <td class="textS">{{luminaria.idDispositivo}}</td>
                <td class="textS">
                  {{getPlano(luminaria.idPlano)}}
                </td>
                <td class="textS">
                  {{getZona(luminaria.idZona)}}
                </td>
              </tr>
            </ng-container>
          </table>
        </div>
      </div>

    </div>

    <div mat-dialog-actions>
      <div class="col" style="text-align: center">
        <button class="customButtonColor textS" mat-button
                (click)="changePageToLista()">{{this.localiser.get("fade.buttonBack")}}</button>
      </div>
      <div *ngIf="!luminariaGuardada" class="col" style="text-align: center">
        <button class="customButtonColor textS" mat-button
                (click)="updateGrupo()">{{this.localiser.get("fade.buttonSave")}}</button>
      </div>
      <div *ngIf="luminariaGuardada" class="col" style="text-align: center">
        <button class="customButtonColorDone textS" mat-button (click)="updateGrupo()">
          {{this.localiser.get("fade.buttonSaved")}}
          <span class="material-icons-outlined marginAuto">done</span>
        </button>
      </div>
    </div>

  </div>

</div>

<div *ngIf="page == 'delete'" class="customPanel">
  <h1 class="textS+" style="text-align: center; height: 7%" mat-dialog-title>
    {{this.localiser.get("fade.groups.deleteTitle")}}
  </h1>

  <div mat-dialog-content class="bodyForm">

    <div class="row rowForm">
      <div class="col">
        <h5 class="textS+">{{this.localiser.get("fade.groups.name")}}</h5>
        <h3 class="textS+">{{nombre}}</h3>
      </div>
      <div class="col">
        <h5 class="textS+">{{this.localiser.get("fade.groups.description")}}</h5>
        <h3 class="textS+">{{descripcion}}</h3>
      </div>
    </div>

    <div class="row rowForm">
      <div class="col">
        <h5 class="textS+">{{this.localiser.get("devices.luminaries")}}</h5>
        <div *ngIf="luminarias.length > 0">
          <h3 *ngFor="let luminaria of luminariasGrupo" class="textS+">{{getLuminariaById(luminaria).nombre}}
            - {{luminaria}}</h3>
        </div>
      </div>
    </div>

  </div>

  <div mat-dialog-actions>
    <div class="col" style="text-align: center">
      <button class="customButtonColor textS" mat-button
              (click)="changePageToLista()">{{this.localiser.get("fade.buttonBack")}}</button>
    </div>
    <div class="col" style="text-align: center">
      <button class="customButtonColorDelete textS" mat-button
              (click)="deleteGrupo()">{{this.localiser.get("fade.delete")}}</button>
    </div>
  </div>
</div>
